import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IMFieldItem } from './typings';

@Component({
  selector: 'm-field-item',
  template: `
    <span class="m-field-picker-item" nz-tooltip [nzTooltipTitle]="tag.name" [ngStyle]="{ border: '1px solid ' + tag.color }">
      {{ tag.name }}
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true
})
export class MFieldItemComponent {
  @Input() tag!: IMFieldItem;
}
